import { MDBAlert, MDBBtn, MDBDatatable, MDBIcon, MDBSpinner } from 'mdb-react-ui-kit';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router';
import { Tooltip } from 'react-tooltip';
import { getLocUsers, getMisc } from '../../../apiclients/streamsapi_bridge';
import PopupLoader from '../../../views/popups/PopupLoader';
import UserMoveLoc from '../../../views/popups/locations/UserMoveLoc';
import { defaultUImg } from '../../images';
function LocUsers(props) {
  const { t, i18n } = useTranslation();
  const toggleShow = () => setBasicModal(!basicModal);
  const [basicModal, setBasicModal] = useState(false);
  const navigate = useNavigate();
  const [locUsersDetails, setLocUserDetails] = useState([]);
  const [MoveUserLocation, setMoveUserLocation] = useState(false);
  const toggleShow24 = () => setMoveUserLocation(!MoveUserLocation);
  const [multiusers, setMultiUsers] = useState(false);
  const [locationList, setLocationList] = useState([]);
  const [agentList, setAgentList] = useState([]);
  const [successMessage, setSuccessMessage] = useState("");
  const [rerender, setRerender] = useState(false);
  const [isloading, setIsloading] = useState(false);
  const [disableMulti, setdisableMulti] = useState(true);


  useEffect(() => {
    if (successMessage) {
      setTimeout(() => {
        setSuccessMessage(""); // Clear the success message in the parent component
      }, 5000);
    }
  }, [successMessage]);


  const moveUser = (e, isMulti, agent) => {
    e.preventDefault();
    e.stopPropagation();
    toggleShow24();
    setMultiUsers(isMulti);
    if (agent) {
      setAgentList([agent])
    }

  }





  async function fetchLocUsers() {
    try {
      console.log("[fetchExistingLocations] ");
      const siteid = JSON.parse(sessionStorage.getItem("admin_session")).siteid;
      const locid = props.locid;
      const extracondition = `?filter_flag=false`;
      setIsloading(true);
      let serverResponse = await getLocUsers(siteid, locid, extracondition);
      setIsloading(false);
      if (!serverResponse.json) {
        const message = `An error has occured: ${serverResponse.statusText}`;
        return;
      }
      const rawData = await serverResponse.json();
      if (!rawData) {
        window.alert(`info with id  not found`);
        navigate("/");
      }
      console.log(rawData);
      setLocUserDetails(rawData?.locations ?? []);
    } catch (error) {
      console.log(`Error in getLocUsers ${error}`);
    }
  }

  async function fetchAllLocations() {
    try {
      let siteid = JSON.parse(sessionStorage.getItem("admin_session")).siteid;
      const params = {
        misc: ["all_locations"],
      };

      const serverResponse = await getMisc(siteid, params);
      if (!serverResponse.ok) {
        console.log("Network response was not ok");
        throw new Error("Network response was not ok");
      } else {
        const responseData = await serverResponse.json();
        console.log("Response Data:", JSON.stringify(responseData));
        const tempLocations = responseData?.misc?.all_locations ?? [];
        const locations = tempLocations.filter((loc) => loc.loc_id != props.locid);


        setLocationList(locations);

      }
    } catch (error) {
      console.error("[fetchAllLocations] Error:", error);
      // Handle the error, show a user-friendly message or log it.
    }
  }

  useEffect(() => {
    if (props.locid && props.locid != "" || rerender) {
      fetchLocUsers();
      fetchAllLocations();
      setRerender(false);
    }

  }, [props.locid, rerender]);


  let proccessdRows = [];
  locUsersDetails.map((user) => {

    proccessdRows.push({
      userObj: user,
      users: (
        <>
          <img
            src={defaultUImg}
            alt=""
            style={{ width: "45px", height: "45px" }}
            className="rounded-circle"
          />
          <span className='ms-2'>
            {user.name}
          </span>
        </>
      ),
      agentid: user.agentid,
      extension: user.extension,
      email: user.email,
      emailverified: (
        <>
          {user.email_verified == "yes" ? (
            <MDBIcon fas icon="check" color='success' className='fw-bold ps-2 ms-4' />
          ) : (
            <h6 class="no-red fw-bold ps-2 ms-4">No</h6>
          )}
        </>
      ),
      service_name: user.seat_plan,
      role: user.role_name,
      move: (
        <>
          {/* <a href='' onClick={(e) => moveUser(e, false, user.agentid)}>
            <MDBIcon fas icon="arrows-alt" className="green" />
          </a> */}

          <div className="d-flex align-items-center ms-2">
            <div className="custom-hover-bg p-1 cursor-pointer deleteToolTip" onClick={(e) => moveUser(e, false, user.agentid)}>
              <MDBIcon fas icon="arrows-alt" color="primary" className="mx-2 fs-5" />
            </div>
          </div>
        </>
      ),
    });
  });

  const actionData = {
    columns: [
      { label: 'Users', field: 'users' },
      { label: 'Extension', field: 'extension', sort: true },
      { label: 'Email', field: 'email', sort: true },
      { label: 'Email Verified', field: 'emailverified', sort: false },
      { label: 'Seat Plan', field: 'service_name', sort: true },
      { label: 'Role', field: 'role', sort: true },
      { label: 'Move', field: 'move', sort: false },
    ],
    rows: proccessdRows,
  };

  function handleCheckedRow(selectedRows) {
    let agents = [];
    selectedRows.forEach((item) => {
      console.log(`Details of row `, JSON.stringify(item.userObj));
      if (item.userObj)
        agents.push(item.userObj.agentid);
    });
    console.log("agentids ::::::: " + JSON.stringify(agents));
    if (agents.length > 1) {
      setdisableMulti(false);
    } else {
      setdisableMulti(true);

    }
    setAgentList(agents);
  }


  return (
    <>
      <h5 className="tabcontent locusersmargintop">
        <MDBBtn
          disabled={disableMulti}
          className="btn btn-primary green-button display-inline float-right me-2 mt-0"
          onClick={(e) => moveUser(e, true)}
        >
          <MDBIcon fas icon="arrows-alt" size="sm" /> {t("moveUser")}
        </MDBBtn>
      </h5>
      <div className='locationUsersDatatble'>
        <MDBDatatable className='actioncolumn' selectable sortField="Users" multi hover data={actionData} entries={50} responsive
          onSelectRow={(selectedRows) => handleCheckedRow(selectedRows)}
        />
      </div>
      {MoveUserLocation && (
        <PopupLoader
          title={multiusers ? t("MoveMultiuserloc") : t("Moveuserloc")}
          content={
            <UserMoveLoc
              locationList={locationList}
              onClose={toggleShow24}
              agentList={agentList}
              setSuccessMessage={setSuccessMessage}
              locDetailsInfo={props.locDetailsInfo}
              setRerender={setRerender}
            />
          }
          onShow={setMoveUserLocation}
          onClose={toggleShow24}
        />
      )}
      {successMessage && (
        <MDBAlert
          open
          className="alert-center"
          color="success"
          autohide
          position="bottom-right"
          delay={10000}
        >
          <i className="fas fa-check-circle me-3"></i>
          <span className="alert-msg">{successMessage}</span>
        </MDBAlert>
      )}
      {isloading && (
        <>
          <div className="loadingclass">
            <MDBBtn disabled>
              <MDBSpinner size="sm" role="status" tag="span" className="me-2" />
              Loading...
            </MDBBtn>
          </div>
        </>
      )}
      <Tooltip anchorSelect=".deleteToolTip" place="top" className="exampleTooltip">
        Move
      </Tooltip>
    </>
  )
}

export default LocUsers
